import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { Cancel } from '../actions/assign-checkbook.actions';
import { CreateNewGroupTemplate } from '../actions/search-group-templates.actions';
import { AssignCheckbook, CloseCheckbooksSidenav, OpenCheckbooksSidenav } from '../actions/sidenav.actions';
import { EditCheckbookGroupTemplate } from '../actions/checkbook-group-template.actions';

export interface SidenavState {
  sidenavStatus: boolean;
  assignCheckbook: boolean;
  checkbookGroupTemplate: boolean;
}

const initialState: SidenavState = {
  sidenavStatus: false,
  assignCheckbook: false,
  checkbookGroupTemplate: false,
};

export const SideNavReducer = createReducer(
  initialState,
  on(OpenCheckbooksSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(CloseCheckbooksSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
    assignCheckbook: false,
    checkbookGroupTemplate: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    sidenavStatus: false,
    assignCheckbook: false,
    checkbookGroupTemplate: false,
  })),
  on(AssignCheckbook, (state) => ({
    ...state,
    assignCheckbook: true,
  })),
  on(CreateNewGroupTemplate, (state) => ({
    ...state,
    sidenavStatus: true,
    checkbookGroupTemplate: true,
  })),
  on(EditCheckbookGroupTemplate, (state) => ({
    ...state,
    sidenavStatus: true,
    checkbookGroupTemplate: true,
  })),
);
